import { useIsCartInFlightRequests } from '@/features/pos/components/Cart/hooks/cart-optimistic-update-counter'
import { useDeferredValue } from 'react'

export const useIsPricesLoading = (orderDraftLoading: boolean): boolean => {
    const isCartInFlightRequests = useIsCartInFlightRequests()

    return useDeferredValue(orderDraftLoading || isCartInFlightRequests)
}
